import { render, staticRenderFns } from "./dui-checkbox.vue?vue&type=template&id=0f476962&"
import script from "./dui-checkbox.vue?vue&type=script&lang=js&"
export * from "./dui-checkbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports